import * as Yup from 'yup'
import * as YupStringTypes from 'yup/lib/string'

export const walletAddressSchema = Yup.string()
  .trim()
  .required('Wallet address is required')
  .test('address-validation', 'Please, indicate a valid wallet address', (value) => {
    return value ? /^0x[a-fA-F0-9]{40}$/.test(value) : false
  }) as YupStringTypes.RequiredStringSchema<string | undefined>
